import * as custom from './custom';

custom.register_custom_blocks();